import {throwError as observableThrowError,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Usuario } from '../../index';
import { environment } from '../../../../environments/environment';
import { catchError } from 'rxjs/operators';
import { Organizacao } from '../../model/organizacao';

@Injectable()
export class AtivacaoService {

    constructor(private http:HttpClient) { }

    validarAtivacaoPasso1(usuario : Usuario) : Observable<any> {
        return this.http.post(environment.backendBaseUrl + '/manager/usuarios/validarAtivacaoPasso1', usuario).pipe(
            catchError(this.handleErrorObservable)
        );
    }

    validarAtivacaoPasso2(usuario : Usuario) : Observable<any> {
        return this.http.post(environment.backendBaseUrl + '/manager/usuarios/validarAtivacaoPasso2', usuario).pipe(
            catchError(this.handleErrorObservable)
        );
    }

    ativar(usuario : Usuario) : Observable<any> {
        return this.http.post(environment.backendBaseUrl + '/manager/usuarios/ativar', usuario).pipe(
            catchError(this.handleErrorObservable)
        );
    }

    obterOrganizacaoDeTokenAtivacao(token: string) :Observable<number> {
        return this.http.get<number>(environment.backendBaseUrl + '/manager/usuarios/obterOrganizacaoDeTokenAtivacao/'+token)
        .pipe(catchError(this.handleErrorObservable));

    }

    private handleErrorObservable (error: HttpErrorResponse | any) {
        console.error(error.error.message);
        return observableThrowError(error.error || error);
    }


    obterOrganizacaoDeTokenAtivacaoV2(token: string) :Observable<Organizacao> {
        return this.http.get<Organizacao>(`${environment.backendBaseUrl}/manager/usuarios/token/${token}/organizacao`)
        .pipe(catchError(this.handleErrorObservable));

    }
}
 